module.exports = {"title":"Show Confirmation","yes":"Confirm","no":"Cancel","description":"This Access Code is for ","description2":" and a production of ","description3":"ShowTix4U will automatically deduct your {0}% royalty from ticket proceeds. If all information is accurate, please click Confirm. If any information needs to be updated, please contact your MTI Rep at 212-541-4684.","description4":"Have a great show!"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/MTIModal/locales/en.json
// module id = 1681
// module chunks = 0